import { useState, useEffect } from 'react';
import * as actions from './actionCreators';
import { useAppContext, useJspVariables, useAuth } from '../hooks';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const PagePasswordRules = ({ showForgotPasswordHelp = false }) => {
    const { jspVariables } = useJspVariables();
    const { getLabelFromJspVariables } = useAppContext(jspVariables);
    const { ssoEnvironment } = useAuth();

    const [passwordMessages, setPasswordMessages] = useState([]);

    useEffect(() => {
        actions.getPasswordMessages().then(resp => {
            setPasswordMessages(resp.data || []);
        }).catch(err => console.error('getPasswordMessages failed:', err));
    }, []);

    const getPasswordMessage = (key) => {
        if (passwordMessages) {
            let msg = null;
            passwordMessages.forEach(m => {
                if (m.uiPlaceHolder == key) {
                    msg = m.message;
                }
            });
            if (msg != null) {
                return msg;
            }
        }
        return '';
    };

    const passwordHelp = getPasswordMessage("PASSWORD_RULES");
    const helpdeskContactUrl = 'https://www.ice.com/contact';

    return (
        <Box sx={{ padding: 0, fontSize: '12px', mt: 1, mb: 0.5 }} id="cp-password-rules-container" data-automation-id="cp_password_rules_container">
            {showForgotPasswordHelp &&
                <Box id="cp-forgot-password" data-automation-id="cp_forgot_password">
                    <Typography variant="body2">{getLabelFromJspVariables('for_assistance_with_reset')}</Typography>
                    <Typography variant="body2">
                        <Link href={helpdeskContactUrl} target="_blank" rel="noopener noreferrer">
                            {getLabelFromJspVariables('helpdesk_contact_block')}
                        </Link>
                    </Typography>
                </Box>
            }
            {!showForgotPasswordHelp &&
                <Box id="cp-password-rules" data-automation-id="cp_password_rules">
                    <Box className="help-notes">
                        <Typography variant="subtitle2" component="h2" fontWeight={600}>{getLabelFromJspVariables('label_password_rules')}</Typography>
                        {passwordHelp ?
                            <Box id="ui-passwordHelp" data-automation-id="ui_password_help" dangerouslySetInnerHTML={{ __html: passwordHelp }} />
                            :
                            <Box component="ul" sx={{ mt: 0.5}}>
                                <li><Typography variant="body2" component="span">{getLabelFromJspVariables('password_length_requirement')}</Typography></li>
                                {ssoEnvironment && ssoEnvironment.showGroupHelp && getLabelFromJspVariables('password_characters_requirement') &&
                                    <li>
                                        <Typography variant="body2" component="span">{getLabelFromJspVariables('password_characters_requirement')}</Typography>
                                        <Box component="ul" sx={{ listStyle: 'none', marginInlineStart: '-40px' }}>
                                            <li><Typography variant="body2" component="span">{getLabelFromJspVariables('passreq_lowercase')}</Typography></li>
                                            <li><Typography variant="body2" component="span">{getLabelFromJspVariables('passreq_uppercase')}</Typography></li>
                                        </Box>
                                    </li>
                                }
                            </Box>
                        }
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default PagePasswordRules;
